// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"ebce0bcc","230":"df1ba799","998":"bdc1f322"}[chunkId] + ".chunk.css";
};